import { Component, OnInit } from '@angular/core';
import {CopyleaksReportConfig, CopyleaksService} from '../../../client/projects/plagiarism-report/src/lib/plagiarism-report/copyleaks-report.module';
import { CopyleaksServiceHelper } from 'src/app/services/copyleaks.service';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs';
import { skip, withLatestFrom } from 'rxjs';
import { UserTypes } from 'src/app/models/userTypes';
import { USER_TYPE } from 'src/app/models/constants';
import { HeaderComponent } from '../header/header.component';
import { NgIf, NgFor } from '@angular/common';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { CopyleaksReportComponent } from '../../../client/projects/plagiarism-report/src/lib/plagiarism-report/copyleaks-report.component';

const DATABASE = "database";
const INTERNET = "internet";

@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.css'],
    imports: [HeaderComponent, NgIf, MatSlideToggle, MatButton, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, NgFor, MatCheckbox, FormsModule, CopyleaksReportComponent]
})
export class ReportComponent implements OnInit {

  config: CopyleaksReportConfig = {};

  filterOptions = [
    {
      value: INTERNET,
      viewValue: "Internet",
      checked: true
    },
    {
      value: DATABASE,
      viewValue: "Database",
      checked: true
    }
  ];

  scanId: string = '';
  isEvaluator: boolean = false;
  isAdmin: boolean = false;
  isCurrentStudent: boolean = false;
  isManualUpload: boolean = false;
  attachmentId: any;
  initialResults: any;
  currentScore: number = 0;
  filteredResults$: Observable<string[]> = this.copyLeaks.filteredResultsIds$;
  scoreUpdates$: Observable<number> = this.copyLeaks.scoreUpdate$;
  isStudentView: boolean = false;
  completeResult: any;
  role:UserTypes = UserTypes.EMA;

  constructor(
    private copyLeaks: CopyleaksService,
    private copyleaksServiceHelper: CopyleaksServiceHelper,
    private route: ActivatedRoute,
    private authService: AuthService,
    private userService: UserService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    if (this.route.snapshot.params['scanId']) {
      this.scanId = this.route.snapshot.params['scanId'];
    }
    // if (this.route.snapshot.params['role'] == 'sam') {
    //   this.role =  UserTypes.SAM;
    //   console.log("It is a SAM user")
    // }
    this.role = sessionStorage.getItem(USER_TYPE) as UserTypes;
    console.log("user role: ", this.role);
    if(this.scanId.includes('_')){
      this.attachmentId = this.scanId.split('_')[1];
    } else {
      this.attachmentId = this.scanId;
      this.isManualUpload = true;
    }
    this.userPermissions();
  }

  userPermissions(){
    this.isEvaluator = this.authService.getIsEvaluator();
    console.log("isEvaluator:",this.isEvaluator );
    if(this.isEvaluator){
      this.userService.getEvaluatorPermissions(this.role).subscribe((resp: any) => {
        this.isAdmin = resp.admin;
        this.initializeConfig();
      });
    }else if(this.scanId.includes(this.authService.getBannerId().toLowerCase())){
      this.isCurrentStudent = true;
      this.initializeConfig();
    }
  }

  initializeConfig(){
    this.config = {
      contentMode: "html",
      download: false,
      help: false,
      disableSuspectBackButton: false,
      options: {
        showPageSources: false,
        showOnlyTopResults: true,
        showRelated: true,
        showIdentical: true,
        showMinorChanges: true,
        setAsDefault: false
      },
      share: false,
      sourcePage: 1,
      suspectPage: 1,
      viewMode: "one-to-many"
    };
    this.buildCopyleaksReport();
  }

  buildCopyleaksReport() {
    this.copyleaksServiceHelper.getSource(this.scanId,this.role).subscribe((resp: any) => {
      this.onPushDownloadedSource(resp);
    });
    this.copyleaksServiceHelper.getCompleteResult(this.scanId,this.role).subscribe((resp: any) => {
      //remove ai score
      if(resp?.scannedDocument?.enabled?.aiDetection){
        resp.scannedDocument.enabled.aiDetection = false;
      }
      
      if(resp?.notifications?.alerts) {
        const index = resp.notifications.alerts.findIndex((result: { code: string; }) => result.code === "suspected-ai-text");
        if(index > -1) resp.notifications.alerts.splice(index, 1);
      }
      this.completeResult = resp;
      this.onPushCompleteResult(resp);
      this.onGetResults(resp);
      this.currentScore = resp.results.score.aggregatedScore;
    });

    this.scoreUpdates$.pipe(
      skip(1),
      withLatestFrom(this.filteredResults$)
    ).subscribe( (res:any) => { 
      this.updateFilteredResults(res) 
    });

    this.copyleaksServiceHelper.getExcludedIds(this.scanId,this.role).subscribe((resp: any) => this.copyLeaks.setFilteredResultsIds(resp, this.currentScore));
  }

  onPushDownloadedSource(crowledSource: any) {
    try{
      this.copyLeaks.pushDownloadedSource(crowledSource);
    }catch(error){
      console.log(error);
    }
  }

  onPushCompleteResult(completeResult: any) {
    this.initialResults = completeResult;
    this.completeResult = completeResult;
    if(!this.isAdmin || this.isStudentView){
      completeResult.results.database.forEach((result: any) => {
        result.metadata?.author ? result.metadata.author = '' : null;
        result.metadata?.filename ? result.metadata.filename = '' : null;
      });
    }else{
      completeResult.results.database.forEach((result: any) => {
        result.metadata?.filename ? result.metadata.filename = result.metadata.filename + '\nScan Id: ' + result.scanId : null;
      });
    }
    if (!completeResult.scannedDocument.creationTime || typeof completeResult.scannedDocument.creationTime === 'undefined') {
      completeResult.scannedDocument.creationTime = new Date().toISOString();
    }
    this.copyLeaks.pushCompletedResult(completeResult);
  }

  async onGetResults(completeResult: any) {
    try {
      let allResults = [
        ...completeResult.results.internet.map((r: any) => ({ id: r.id, isDatabase: false })),
        ...completeResult.results.database.map((r: any) => ({ id: r.id, isDatabase: true })),
        ...completeResult.results.batch.map((r: any) => ({ id: r.id, isDatabase: false })),
        ...completeResult.results.repositories.map((r: any) => ({ id: r.id, isDatabase: false })),
      ];

      for(const result of allResults){
        this.copyLeaks.deleteResultById(result.id)
      }

      this.copyLeaks.pushCompletedResult(this.completeResult);
  
      for (const result of allResults) {
        this.onPushScanResults(result.id, result.isDatabase);
      }
    } catch (error) {
      console.log(error);
    }
  }

  onPushScanResults(id: string, isDatabase: boolean){
    this.copyleaksServiceHelper.getReport(this.scanId, id,this.role)
      .subscribe((result: any) => {
        let disabled = isDatabase && (this.isCurrentStudent || this.isStudentView);
        let scanResult = {
          id: id,
          result: result,
          disabled: disabled
        }
        
        this.copyLeaks.pushScanResult(scanResult);
      });
  }

  onShareBtnClick(event:any){}

  onDownloadStudentSubmissionBtnClick(){
    this.copyleaksServiceHelper.getStudentSubmissionAttachment(this.attachmentId,this.role);
  }

  adminMenuClick(event: any, actionType: String, actionSubType: String){
    event.stopPropagation();
    switch (actionType) {
      case "download":
        switch(actionSubType){
          case 'studentSub':
            this.onDownloadStudentSubmissionBtnClick();
            break;
          case 'similarityReport':
            this.onDownloadPDFReport();
            break;
          case 'dbMatches':
            this.onDownloadDBMatches();
            break;
        }
        break;

      case "filter":
        let isIncludeDatabase = this.filterOptions.find(it => it.value === DATABASE)?.checked;
        let isIncludeInternet = this.filterOptions.find(it => it.value === INTERNET)?.checked;

        if (actionSubType === DATABASE) {
          isIncludeDatabase = !isIncludeDatabase;
        } else if (actionSubType === INTERNET) {
          isIncludeInternet = !isIncludeInternet;
        }

        const filteredResults = {
          ...this.initialResults,
          results: {
            ...this.initialResults.results,
            database: isIncludeDatabase ? this.initialResults.results.database : [],
            internet: isIncludeInternet ? this.initialResults.results.internet : [],
          }
        }
        this.copyLeaks.pushCompletedResult(filteredResults);
        window.setTimeout(() => {
          const closeAlertsBtn = document.querySelector('[mattooltip="Close alerts"]');
          // @ts-ignore
          closeAlertsBtn?.click()
        }, 30)
        break;

      default:
        console.error("Unable to complete action:" + actionType);
        break;
    }
  }

  updateFilteredResults(results: [number, string[]]) {
    let excludedIds = results[1];
    let score = Math.round(results[0] * 10000) / 100;
    if(this.isAdmin){
      this.copyleaksServiceHelper.updateExcludedResults(this.scanId, score.toString(), excludedIds,this.role).subscribe({
        next: (v) => ({}),
        error: (e) => ({})
      })
    }
  }

  switchStudentView() {
    this.isStudentView = !this.isStudentView;
    this.initializeConfig();
  }

  private onDownloadPDFReport() {
    console.log("Downloading PDF report with attachmentId:",this.attachmentId)
    this.copyleaksServiceHelper.getPDFReportByAttachmentId(this.attachmentId,this.scanId,this.role);
  }

  private onDownloadDBMatches() {
    console.log("Downloading DB Matches: ",this.scanId)
    this.copyleaksServiceHelper.getDBMatchesByScanId(this.scanId,this.role);
  }
}
